// src/pages/Product/InverterComparison.jsx
import React from "react";
import "./InverterComparison.css";

const FALLBACK_IMAGE = "https://placehold.co/500x600/0a0a0a/333?text=Inverter";

const InverterComparison = ({ productImage }) => {
  const sideImage1 =
    "https://res.cloudinary.com/dhbjxspxa/image/upload/v1778685719/products/uxazvitijtjqbttkzqzi.jpg";
  const sideImage2 =
    "https://res.cloudinary.com/dhbjxspxa/image/upload/v1778685724/products/imj1k6gw1uhockb3qvwp.jpg";

  const comparisonData = [
    {
      feature: "Features",
      tradValue: "Outdated Tech",
      zynValue: "Modern Zynventics Tech",
      isHeaderRow: true,
    },
    {
      feature: "Battery Life",
      tradValue: "✖ 2 - 3 Years (300-500 cycles)",
      zynValue: "✔ 7 - 10 Years (2000+ cycles)",
      zynHighlight: "Longest lifespan",
    },
    {
      feature: "Charging Time",
      tradValue: "✖ 10 - 12 Hours",
      zynValue: "✔ 2 - 4 Hours (Fast Charge)",
      zynHighlight: "Charges 3× faster",
    },
    {
      feature: "Electricity Consumption",
      tradValue: "✖ High (Loses up to 20% as heat)",
      zynValue: "✔ Very Low (95%+ DSP Efficiency)",
      zynHighlight: "Saves money on bills",
    },
    {
      feature: "Maintenance Hassles",
      tradValue: "✖ Requires distilled water top-ups",
      zynValue: "✔ 100% Maintenance-Free",
      zynHighlight: "Completely worry-free",
    },
    {
      feature: "Long Term Savings",
      tradValue: "✖ Low (Frequent replacements)",
      zynValue: "✔ Maximum",
      zynHighlight: "Best long-term value",
    },
    {
      feature: "Space Optimization",
      tradValue: "✖ Requires separate battery trolley",
      zynValue: "✔ Self-Contained, Stackable Design",
      zynHighlight: "Saves 60% space",
    },
    {
      feature: "Auto Voltage Regulation",
      tradValue: "✖ Not Available",
      zynValue: "✔ DSP-Controlled",
      zynHighlight: "Protects appliances",
    },
    {
      feature: "Smart App Control",
      tradValue: "✖ Not Available",
      zynValue: "✔ Bluetooth / Wi-Fi Enabled",
      zynHighlight: "Monitor remotely",
    },
  ];

  return (
    <div className="inverter-comparison-wrapper">
      {/* LEFT SIDE: Table Content */}
      <div className="comparison-content-left">
        <h2 className="comparison-title">The Zynventics Difference</h2>
        <p className="comparison-subtitle">
          See exactly why modern Indian homes are making the switch from
          outdated tech.
        </p>

        <div className="comparison-table-layout">
          {comparisonData.map((item, index) => (
            <div
              key={item.feature}
              className={`comparison-row ${item.isHeaderRow ? "header-row" : ""}`}
            >
              <div className="feature-col">
                {index === 0 ? "Features" : item.feature}
              </div>

              {item.isHeaderRow ? (
                <>
                  <div className="value-col trad-col">
                    <span className="header-title">Traditional Inverter</span>
                    <span className="tech-subtitle">Lead-Acid Setup</span>
                  </div>
                  <div className="value-col zyn-col">
                    <span className="header-title zyn-blue">
                      Zynventics Inverter
                    </span>
                    <span className="tech-subtitle">
                      Advanced Lithium Setup
                    </span>
                  </div>
                </>
              ) : (
                <>
                  <div className="value-col trad-col">
                    <span className="value-text">{item.tradValue}</span>
                  </div>
                  <div className="value-col zyn-col highlighted-col">
                    <span className="value-text zyn-text">{item.zynValue}</span>
                    <div className="highlight-tag">{item.zynHighlight}</div>
                  </div>
                </>
              )}
            </div>
          ))}
        </div>
      </div>

      {/* RIGHT SIDE: Full Height Hardware Showcase */}
      <div className="product-showcase-right">
        <div className="comp-showcase-container">
          {/* TOP: Front Panel (Aligned to Table Top) */}
          <div className="hardware-section showcase-top">
            <img
              src={productImage || FALLBACK_IMAGE}
              alt="Zynventics Front Panel"
              className="comp-hero-img"
              onError={(e) => (e.target.src = FALLBACK_IMAGE)}
            />
            <div className="recommended-badge">RECOMMENDED</div>
          </div>

          {/* MIDDLE: Gap Filler Animations & Callouts */}
          <div className="hardware-section showcase-middle">
            <div className="animated-connector-line"></div>
            <div className="middle-features-list">
              <div className="feature-callout">
                <span className="pulse-dot solar"></span>
                <div className="callout-text">
                  <strong>Solar Ready Connector</strong>
                  <span>Direct plug-in for MPPT/PWM charge controllers</span>
                </div>
              </div>
              <div className="feature-callout">
                <span className="pulse-dot safety"></span>
                <div className="callout-text">
                  <strong>Battery MCB & Main Breaker</strong>
                  <span>Dual-layer circuit protection for total safety</span>
                </div>
              </div>
              <div className="feature-callout">
                <span className="pulse-dot power"></span>
                <div className="callout-text">
                  <strong>15Amp Heavy Socket</strong>
                  <span>Built to run high-load appliances effortlessly</span>
                </div>
              </div>
            </div>
            <div className="animated-connector-line"></div>
          </div>

          {/* BOTTOM: Side Panels (Aligned to Table Bottom) */}
          <div className="hardware-section showcase-bottom">
            <div className="comp-dual-wrap">
              <div className="side-img-wrapper">
                <img
                  src={sideImage1}
                  alt="Left Panel"
                  className="comp-dual-img"
                />
                <span className="panel-label">Left Panel (Inputs)</span>
              </div>
              <div className="side-img-wrapper">
                <img
                  src={sideImage2}
                  alt="Right Panel"
                  className="comp-dual-img"
                />
                <span className="panel-label">Right Panel (Outputs)</span>
              </div>
            </div>
            <h3 className="zyn-logo">Zynventics</h3>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InverterComparison;
